import { useChatContext } from '../../../context';
import { useStateStore } from '../../../store';
const selector = (state) => ({
    notifications: state.notifications,
});
export const useNotifications = () => {
    const { client } = useChatContext();
    const result = useStateStore(client.notifications.store, selector);
    return result.notifications;
};
